
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("g891Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animator = void 0;
var $bbe4659a6535432d$var$Animator = /** @class */ function() {
    function Animator(timelines) {
        this._pausedTime = undefined;
        this._lastTime = Date.now();
        this._startTime = Date.now();
        this._timelines = timelines;
        this._animationFrame = null;
    }
    Object.defineProperty(Animator.prototype, "isRunning", {
        get: function() {
            return Boolean(this._animationFrame);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Animator.prototype, "startTime", {
        get: function() {
            return this._startTime;
        },
        set: function(startTime) {
            this._startTime = startTime;
        },
        enumerable: false,
        configurable: true
    });
    Animator.prototype.onTick = function(onTick) {
        this._onTick = onTick;
    };
    Animator.prototype.onStep = function(onStep) {
        this._onStep = onStep;
    };
    Animator.prototype.computeFrameAt = function(time) {
        var _a;
        var elapsedTime = time - this._startTime;
        var deltaTime = (time - this._lastTime) / 1000; // In sec
        this._lastTime = time;
        for(var _i = 0, _b = this._timelines; _i < _b.length; _i++){
            var timeline = _b[_i];
            var timelineTime = elapsedTime % timeline.totalDuration;
            var step = timeline.getCurrentStep(timelineTime);
            if (step) {
                var durationUntilStep = timeline.getDurationUntilStep(step);
                var stepTime = (timelineTime - durationUntilStep) / step.duration;
                /**
                 * Trigger the on start callback on the first frame of a step.
                 */ if (step !== timeline.lastStep || timeline.lastStepTime > stepTime) {
                    if ((_a = timeline.lastStep) === null || _a === void 0 ? void 0 : _a.onEnd) timeline.lastStep.onEnd();
                    if (step.onStart) step.onStart();
                    if (this._onStep) this._onStep(elapsedTime, step, deltaTime);
                }
                if (step.handler) step.handler(stepTime, deltaTime);
                if (this._onTick) this._onTick(elapsedTime, step, deltaTime);
                timeline.lastStepTime = stepTime;
                timeline.lastStep = step;
            } else this.stop();
        }
    };
    Animator.prototype.loop = function() {
        var _this = this;
        this._animationFrame = requestAnimationFrame(function() {
            _this.computeFrameAt(Date.now());
            _this.loop();
        });
    };
    Animator.prototype.start = function() {
        if (typeof this._pausedTime !== 'undefined') {
            var deltaTime = this._pausedTime - this._startTime;
            this._startTime = Date.now() - deltaTime;
        } else this._startTime = Date.now();
        this._lastTime = Date.now();
        this._pausedTime = undefined;
        this.loop();
    };
    Animator.prototype.stop = function() {
        if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
        this._pausedTime = undefined;
        this._animationFrame = null;
    };
    Animator.prototype.pause = function() {
        if (this._animationFrame) cancelAnimationFrame(this._animationFrame);
        this._pausedTime = Date.now();
        this._animationFrame = null;
    };
    Animator.prototype.getDuration = function() {
        return Math.max.apply(Math, this._timelines.map(function(timeline) {
            return timeline.getDuration();
        }));
    };
    return Animator;
}();
module.exports.Animator = $bbe4659a6535432d$var$Animator;

});

parcelRegister("6UNk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeline = void 0;
var $508e3ba6c29eee25$var$Timeline = /** @class */ function() {
    function Timeline(steps) {
        this._steps = steps;
        this._lastStepTime = 0;
        this._lastStep = null;
    }
    Object.defineProperty(Timeline.prototype, "totalDuration", {
        get: function() {
            return this._steps.reduce(function(acc, step) {
                return acc += step.duration;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timeline.prototype, "lastStep", {
        get: function() {
            return this._lastStep;
        },
        set: function(lastStep) {
            this._lastStep = lastStep;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timeline.prototype, "lastStepTime", {
        get: function() {
            return this._lastStepTime;
        },
        set: function(lastStepTime) {
            this._lastStepTime = lastStepTime;
        },
        enumerable: false,
        configurable: true
    });
    Timeline.prototype.getCurrentStep = function(time) {
        var currentTime = 0;
        for(var _i = 0, _a = this._steps; _i < _a.length; _i++){
            var step = _a[_i];
            if (time <= currentTime + step.duration) return step;
            currentTime += step.duration;
        }
        return this._steps[this._steps.length - 1];
    };
    Timeline.prototype.getDurationUntilStep = function(step) {
        var stepIndex = this._steps.indexOf(step);
        var beforeSteps = this._steps.slice(0, stepIndex);
        return beforeSteps.reduce(function(acc, it) {
            return acc += it.duration;
        }, 0);
    };
    Timeline.prototype.getDuration = function() {
        return this._steps.reduce(function(duration, step) {
            duration += step.duration;
            return duration;
        }, 0);
    };
    return Timeline;
}();
module.exports.Timeline = $508e3ba6c29eee25$var$Timeline;

});

parcelRegister("84Oda", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Step = void 0;
var $01847a68e117b7b2$var$Step = /** @class */ function() {
    function Step() {
        this.duration = 0;
    }
    return Step;
}();
module.exports.Step = $01847a68e117b7b2$var$Step;

});

var $e3ca45106609cc0f$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1LzKV\",\"index.63d0c776.js\",\"fATbh\",\"r.3ce1aa41.svg\",\"7eD6n\",\"m.0f82f70b.svg\"]"));

var $9ee3fca5db518720$exports = {};
"use strict";
Object.defineProperty($9ee3fca5db518720$exports, "__esModule", {
    value: true
});
function $9ee3fca5db518720$var$easeInQuad(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * (elapsed /= duration) * elapsed + initialValue;
}
$9ee3fca5db518720$exports.easeInQuad = $9ee3fca5db518720$var$easeInQuad;
function $9ee3fca5db518720$var$easeOutQuad(elapsed, initialValue, amountOfChange, duration) {
    return -amountOfChange * (elapsed /= duration) * (elapsed - 2) + initialValue;
}
$9ee3fca5db518720$exports.easeOutQuad = $9ee3fca5db518720$var$easeOutQuad;
function $9ee3fca5db518720$var$easeInOutQuad(elapsed, initialValue, amountOfChange, duration) {
    if ((elapsed /= duration / 2) < 1) return amountOfChange / 2 * elapsed * elapsed + initialValue;
    return -amountOfChange / 2 * (--elapsed * (elapsed - 2) - 1) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutQuad = $9ee3fca5db518720$var$easeInOutQuad;
function $9ee3fca5db518720$var$easeInCubic(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * (elapsed /= duration) * elapsed * elapsed + initialValue;
}
$9ee3fca5db518720$exports.easeInCubic = $9ee3fca5db518720$var$easeInCubic;
function $9ee3fca5db518720$var$easeOutCubic(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * ((elapsed = elapsed / duration - 1) * elapsed * elapsed + 1) + initialValue;
}
$9ee3fca5db518720$exports.easeOutCubic = $9ee3fca5db518720$var$easeOutCubic;
function $9ee3fca5db518720$var$easeInOutCubic(elapsed, initialValue, amountOfChange, duration) {
    if ((elapsed /= duration / 2) < 1) return amountOfChange / 2 * elapsed * elapsed * elapsed + initialValue;
    return amountOfChange / 2 * ((elapsed -= 2) * elapsed * elapsed + 2) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutCubic = $9ee3fca5db518720$var$easeInOutCubic;
function $9ee3fca5db518720$var$easeInQuart(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * (elapsed /= duration) * elapsed * elapsed * elapsed + initialValue;
}
$9ee3fca5db518720$exports.easeInQuart = $9ee3fca5db518720$var$easeInQuart;
function $9ee3fca5db518720$var$easeOutQuart(elapsed, initialValue, amountOfChange, duration) {
    return -amountOfChange * ((elapsed = elapsed / duration - 1) * elapsed * elapsed * elapsed - 1) + initialValue;
}
$9ee3fca5db518720$exports.easeOutQuart = $9ee3fca5db518720$var$easeOutQuart;
function $9ee3fca5db518720$var$easeInOutQuart(elapsed, initialValue, amountOfChange, duration) {
    if ((elapsed /= duration / 2) < 1) return amountOfChange / 2 * elapsed * elapsed * elapsed * elapsed + initialValue;
    return -amountOfChange / 2 * ((elapsed -= 2) * elapsed * elapsed * elapsed - 2) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutQuart = $9ee3fca5db518720$var$easeInOutQuart;
function $9ee3fca5db518720$var$easeInQuint(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * (elapsed /= duration) * elapsed * elapsed * elapsed * elapsed + initialValue;
}
$9ee3fca5db518720$exports.easeInQuint = $9ee3fca5db518720$var$easeInQuint;
function $9ee3fca5db518720$var$easeOutQuint(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * ((elapsed = elapsed / duration - 1) * elapsed * elapsed * elapsed * elapsed + 1) + initialValue;
}
$9ee3fca5db518720$exports.easeOutQuint = $9ee3fca5db518720$var$easeOutQuint;
function $9ee3fca5db518720$var$easeInOutQuint(elapsed, initialValue, amountOfChange, duration) {
    if ((elapsed /= duration / 2) < 1) return amountOfChange / 2 * elapsed * elapsed * elapsed * elapsed * elapsed + initialValue;
    return amountOfChange / 2 * ((elapsed -= 2) * elapsed * elapsed * elapsed * elapsed + 2) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutQuint = $9ee3fca5db518720$var$easeInOutQuint;
function $9ee3fca5db518720$var$easeInSine(elapsed, initialValue, amountOfChange, duration) {
    return -amountOfChange * Math.cos(elapsed / duration * (Math.PI / 2)) + amountOfChange + initialValue;
}
$9ee3fca5db518720$exports.easeInSine = $9ee3fca5db518720$var$easeInSine;
function $9ee3fca5db518720$var$easeOutSine(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * Math.sin(elapsed / duration * (Math.PI / 2)) + initialValue;
}
$9ee3fca5db518720$exports.easeOutSine = $9ee3fca5db518720$var$easeOutSine;
function $9ee3fca5db518720$var$easeInOutSine(elapsed, initialValue, amountOfChange, duration) {
    return -amountOfChange / 2 * (Math.cos(Math.PI * elapsed / duration) - 1) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutSine = $9ee3fca5db518720$var$easeInOutSine;
function $9ee3fca5db518720$var$easeInExpo(elapsed, initialValue, amountOfChange, duration) {
    return elapsed === 0 ? initialValue : amountOfChange * Math.pow(2, 10 * (elapsed / duration - 1)) + initialValue;
}
$9ee3fca5db518720$exports.easeInExpo = $9ee3fca5db518720$var$easeInExpo;
function $9ee3fca5db518720$var$easeOutExpo(elapsed, initialValue, amountOfChange, duration) {
    return elapsed === duration ? initialValue + amountOfChange : amountOfChange * (-Math.pow(2, -10 * elapsed / duration) + 1) + initialValue;
}
$9ee3fca5db518720$exports.easeOutExpo = $9ee3fca5db518720$var$easeOutExpo;
function $9ee3fca5db518720$var$easeInOutExpo(elapsed, initialValue, amountOfChange, duration) {
    if (elapsed === 0) return initialValue;
    if (elapsed === duration) return initialValue + amountOfChange;
    if ((elapsed /= duration / 2) < 1) return amountOfChange / 2 * Math.pow(2, 10 * (elapsed - 1)) + initialValue;
    return amountOfChange / 2 * (-Math.pow(2, -10 * --elapsed) + 2) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutExpo = $9ee3fca5db518720$var$easeInOutExpo;
function $9ee3fca5db518720$var$easeInCirc(elapsed, initialValue, amountOfChange, duration) {
    return -amountOfChange * (Math.sqrt(1 - (elapsed /= duration) * elapsed) - 1) + initialValue;
}
$9ee3fca5db518720$exports.easeInCirc = $9ee3fca5db518720$var$easeInCirc;
function $9ee3fca5db518720$var$easeOutCirc(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange * Math.sqrt(1 - (elapsed = elapsed / duration - 1) * elapsed) + initialValue;
}
$9ee3fca5db518720$exports.easeOutCirc = $9ee3fca5db518720$var$easeOutCirc;
function $9ee3fca5db518720$var$easeInOutCirc(elapsed, initialValue, amountOfChange, duration) {
    if ((elapsed /= duration / 2) < 1) return -amountOfChange / 2 * (Math.sqrt(1 - elapsed * elapsed) - 1) + initialValue;
    return amountOfChange / 2 * (Math.sqrt(1 - (elapsed -= 2) * elapsed) + 1) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutCirc = $9ee3fca5db518720$var$easeInOutCirc;
function $9ee3fca5db518720$var$easeInElastic(elapsed, initialValue, amountOfChange, duration) {
    var s = 1.70158;
    var p = 0;
    var a = amountOfChange;
    if (elapsed === 0) return initialValue;
    if ((elapsed /= duration) === 1) return initialValue + amountOfChange;
    if (!p) p = duration * 0.3;
    if (a < Math.abs(amountOfChange)) {
        a = amountOfChange;
        s = p / 4;
    } else s = p / (2 * Math.PI) * Math.asin(amountOfChange / a);
    return -(a * Math.pow(2, 10 * (elapsed -= 1)) * Math.sin((elapsed * duration - s) * (2 * Math.PI) / p)) + initialValue;
}
$9ee3fca5db518720$exports.easeInElastic = $9ee3fca5db518720$var$easeInElastic;
function $9ee3fca5db518720$var$easeOutElastic(elapsed, initialValue, amountOfChange, duration) {
    var s = 1.70158;
    var p = 0;
    var a = amountOfChange;
    if (elapsed === 0) return initialValue;
    if ((elapsed /= duration) === 1) return initialValue + amountOfChange;
    if (!p) p = duration * 0.3;
    if (a < Math.abs(amountOfChange)) {
        a = amountOfChange;
        s = p / 4;
    } else s = p / (2 * Math.PI) * Math.asin(amountOfChange / a);
    return a * Math.pow(2, -10 * elapsed) * Math.sin((elapsed * duration - s) * (2 * Math.PI) / p) + amountOfChange + initialValue;
}
$9ee3fca5db518720$exports.easeOutElastic = $9ee3fca5db518720$var$easeOutElastic;
function $9ee3fca5db518720$var$easeInOutElastic(elapsed, initialValue, amountOfChange, duration) {
    var s = 1.70158;
    var p = 0;
    var a = amountOfChange;
    if (elapsed === 0) return initialValue;
    if ((elapsed /= duration / 2) === 2) return initialValue + amountOfChange;
    if (!p) p = duration * (0.3 * 1.5);
    if (a < Math.abs(amountOfChange)) {
        a = amountOfChange;
        s = p / 4;
    } else s = p / (2 * Math.PI) * Math.asin(amountOfChange / a);
    if (elapsed < 1) return -0.5 * (a * Math.pow(2, 10 * (elapsed -= 1)) * Math.sin((elapsed * duration - s) * (2 * Math.PI) / p)) + initialValue;
    return a * Math.pow(2, -10 * (elapsed -= 1)) * Math.sin((elapsed * duration - s) * (2 * Math.PI) / p) * 0.5 + amountOfChange + initialValue;
}
$9ee3fca5db518720$exports.easeInOutElastic = $9ee3fca5db518720$var$easeInOutElastic;
function $9ee3fca5db518720$var$easeInBack(elapsed, initialValue, amountOfChange, duration, s) {
    if (s === void 0) s = 1.70158;
    return amountOfChange * (elapsed /= duration) * elapsed * ((s + 1) * elapsed - s) + initialValue;
}
$9ee3fca5db518720$exports.easeInBack = $9ee3fca5db518720$var$easeInBack;
function $9ee3fca5db518720$var$easeOutBack(elapsed, initialValue, amountOfChange, duration, s) {
    if (s === void 0) s = 1.70158;
    return amountOfChange * ((elapsed = elapsed / duration - 1) * elapsed * ((s + 1) * elapsed + s) + 1) + initialValue;
}
$9ee3fca5db518720$exports.easeOutBack = $9ee3fca5db518720$var$easeOutBack;
function $9ee3fca5db518720$var$easeInOutBack(elapsed, initialValue, amountOfChange, duration, s) {
    if (s === void 0) s = 1.70158;
    if ((elapsed /= duration / 2) < 1) return amountOfChange / 2 * (elapsed * elapsed * (((s *= 1.525) + 1) * elapsed - s)) + initialValue;
    return amountOfChange / 2 * ((elapsed -= 2) * elapsed * (((s *= 1.525) + 1) * elapsed + s) + 2) + initialValue;
}
$9ee3fca5db518720$exports.easeInOutBack = $9ee3fca5db518720$var$easeInOutBack;
function $9ee3fca5db518720$var$easeInBounce(elapsed, initialValue, amountOfChange, duration) {
    return amountOfChange - $9ee3fca5db518720$var$easeOutBounce(duration - elapsed, 0, amountOfChange, duration) + initialValue;
}
$9ee3fca5db518720$exports.easeInBounce = $9ee3fca5db518720$var$easeInBounce;
function $9ee3fca5db518720$var$easeOutBounce(elapsed, initialValue, amountOfChange, duration) {
    if ((elapsed /= duration) < 1 / 2.75) return amountOfChange * (7.5625 * elapsed * elapsed) + initialValue;
    else if (elapsed < 2 / 2.75) return amountOfChange * (7.5625 * (elapsed -= 1.5 / 2.75) * elapsed + 0.75) + initialValue;
    else if (elapsed < 2.5 / 2.75) return amountOfChange * (7.5625 * (elapsed -= 2.25 / 2.75) * elapsed + 0.9375) + initialValue;
    else return amountOfChange * (7.5625 * (elapsed -= 2.625 / 2.75) * elapsed + 0.984375) + initialValue;
}
$9ee3fca5db518720$exports.easeOutBounce = $9ee3fca5db518720$var$easeOutBounce;
function $9ee3fca5db518720$var$easeInOutBounce(elapsed, initialValue, amountOfChange, duration) {
    if (elapsed < duration / 2) return $9ee3fca5db518720$var$easeInBounce(elapsed * 2, 0, amountOfChange, duration) * 0.5 + initialValue;
    return $9ee3fca5db518720$var$easeOutBounce(elapsed * 2 - duration, 0, amountOfChange, duration) * 0.5 + amountOfChange * 0.5 + initialValue;
}
$9ee3fca5db518720$exports.easeInOutBounce = $9ee3fca5db518720$var$easeInOutBounce;


var $33b981ac7a75a4a6$exports = {};
"use strict";
var $33b981ac7a75a4a6$var$__createBinding = $33b981ac7a75a4a6$exports && $33b981ac7a75a4a6$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $33b981ac7a75a4a6$var$__exportStar = $33b981ac7a75a4a6$exports && $33b981ac7a75a4a6$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $33b981ac7a75a4a6$var$__createBinding(exports1, m, p);
};
Object.defineProperty($33b981ac7a75a4a6$exports, "__esModule", {
    value: true
});

$33b981ac7a75a4a6$var$__exportStar((parcelRequire("g891Q")), $33b981ac7a75a4a6$exports);

$33b981ac7a75a4a6$var$__exportStar((parcelRequire("6UNk7")), $33b981ac7a75a4a6$exports);

$33b981ac7a75a4a6$var$__exportStar((parcelRequire("84Oda")), $33b981ac7a75a4a6$exports);


var $04410b3b959a494a$export$751816bfcb437aef = function(animationElement) {
    animationElement.innerHTML = "";
};
var $04410b3b959a494a$export$1860c7b6fa9bf376 = function(element, style) {
    for(var _i = 0, _a = Object.entries(style); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        element.style[key] = value;
    }
};
var $04410b3b959a494a$export$e6113b5ca55f1c92 = function(animationElement, textElement, item, state) {
    state.lines = [];
    textElement.innerHTML = "";
    textElement.removeAttribute("style");
    if (item.style) Object.entries(item.style).forEach(function(_a) {
        var key = _a[0], value = _a[1];
        textElement.style[key] = value;
    });
    item.lines.forEach(function(line) {
        var lineElement = document.createElement("span");
        lineElement.innerText = line.text;
        lineElement.style.fontSize = "".concat(line.size, "vw");
        lineElement.style.scale = "".concat(line.scale || 1);
        lineElement.style.transform = "translate3d(".concat(line.x || 0, "vw, ").concat(line.y || 0, "vw, 0)");
        textElement.appendChild(lineElement);
        state.lines.push(lineElement);
    });
};
var $04410b3b959a494a$export$5198eece9057abd5 = function(progress, start, target) {
    return {
        ital: start.ital + (target.ital - start.ital) * progress,
        wght: start.wght + (target.wght - start.wght) * progress,
        wdth: start.wdth + (target.wdth - start.wdth) * progress
    };
};
var $04410b3b959a494a$export$1b1be0204c0cf7ec = function(sections) {
    var totalProgressFactor = sections.reduce(function(acc, section) {
        return acc += section.percent;
    }, 0);
    return {
        compute: function(progress) {
            var remappedProgress = totalProgressFactor * progress;
            var currentSection = undefined;
            var currentSectionProgress = 0;
            for(var _i = 0, sections_1 = sections; _i < sections_1.length; _i++){
                var section = sections_1[_i];
                if (remappedProgress >= currentSectionProgress && remappedProgress < currentSectionProgress + section.percent) {
                    currentSection = section;
                    break;
                }
                currentSectionProgress += section.percent;
            }
            if (currentSection) {
                var sectionProgress = (remappedProgress - currentSectionProgress) / currentSection.percent;
                currentSection.handler(sectionProgress);
            }
        }
    };
};
var $04410b3b959a494a$export$95df08bae54cb4df = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var $04410b3b959a494a$export$6446a186d09e379e = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
var $04410b3b959a494a$export$f65a7599bbc6b121 = function(value, low1, high1, low2, high2) {
    return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
};
var $04410b3b959a494a$export$7ad24b426ce99d11 = function(array) {
    return array[Math.floor(Math.random() * array.length)];
};
var $04410b3b959a494a$export$7813ac9aa7ad33ad = function(item, array) {
    var index = array.indexOf(item);
    var randomIndex = Math.floor(Math.random() * (array.length - 1)) + 1;
    var nextIndex = (index + randomIndex) % array.length;
    return array[nextIndex];
};
var $04410b3b959a494a$export$448332262467e042 = function(array) {
    var _a;
    var currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex != 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        _a = [
            array[randomIndex],
            array[currentIndex]
        ], array[currentIndex] = _a[0], array[randomIndex] = _a[1];
    }
    return array;
};
var $04410b3b959a494a$export$dbb89ba2b1e2f9f5 = function(progress, origin, target) {
    return origin.map(function(it, index) {
        return it + (target[index] - it) * progress;
    });
};
var $04410b3b959a494a$export$7d15b64cf5a3a4c4 = function(value, min, max) {
    return Math.min(Math.max(value, min), max);
};
var $04410b3b959a494a$export$47a3d634abc09f70 = function(element, initialChunks) {
    if (initialChunks === void 0) initialChunks = [];
    var lastChunks = initialChunks;
    return {
        render: function(progress, chunks) {
            var word = chunks.map(function(it) {
                return it.text;
            }).join("");
            if (word === element.innerText.split("\n").join("")) lastChunks = chunks;
            var diff = Math.abs(lastChunks.length - chunks.length);
            var longerChunks = lastChunks.length > chunks.length ? lastChunks : chunks;
            var finalCunks = longerChunks.slice(0, longerChunks.length - Math.floor((lastChunks.length > chunks.length ? progress : 1 - progress) * (diff + 1)));
            element.innerHTML = "";
            finalCunks.forEach(function(it) {
                var child = document.createElement("span");
                child.innerText = it.text;
                $04410b3b959a494a$export$1860c7b6fa9bf376(child, it.style || {});
                element.appendChild(child);
            });
        }
    };
};


var $51b72d08bf373ed7$export$ca000e230c0caa3e = {
    background: [
        0,
        0,
        0
    ],
    color: [
        255,
        255,
        255
    ],
    enableFade: true,
    fadeDuration: 1000
};
var $51b72d08bf373ed7$export$741788f7de9fd38b = function(enable) {
    $51b72d08bf373ed7$export$ca000e230c0caa3e.enableFade = enable;
};
var $51b72d08bf373ed7$export$2e65e79124cca55d = function(r, g, b) {
    $51b72d08bf373ed7$export$ca000e230c0caa3e.background = [
        r,
        g,
        b
    ];
};
var $51b72d08bf373ed7$export$130a5dc1bc9cd8e1 = function(r, g, b) {
    $51b72d08bf373ed7$export$ca000e230c0caa3e.color = [
        r,
        g,
        b
    ];
};
var $51b72d08bf373ed7$export$7690ef3549dca89 = function(duration) {
    $51b72d08bf373ed7$export$ca000e230c0caa3e.fadeDuration = duration;
};


var $c660f982237dac0a$export$b3bfe11f31710c32 = 3;
var $c660f982237dac0a$export$f827a56aa9dbfe62 = "12.5vw";
var $c660f982237dac0a$export$358411d2f8db662d = "Artex";
var $c660f982237dac0a$export$2cf867adcf7b7e04 = "Movement";
var $c660f982237dac0a$export$b9b2ffbd9afd176b = "Le Mans";
var $c660f982237dac0a$export$c6e865902d807c3b = "100px 30px";
var $c660f982237dac0a$export$a5335760cf6c4e1c = "rows-3";
var $c660f982237dac0a$export$a3e012875989e44 = "row-1";


var $569ebc0e763c3fcc$var$duration = 1800;
var $569ebc0e763c3fcc$var$animationDuration = 1300;
var $569ebc0e763c3fcc$export$17e504b52161a67b = function(animationElement, textElement) {
    return {
        duration: $569ebc0e763c3fcc$var$duration,
        onStart: function() {
            console.log("step 1");
            (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(255, 255, 255);
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            for(var i = 0; i < (0, $c660f982237dac0a$export$b3bfe11f31710c32); i++){
                var line = document.createElement("span");
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    opacity: "0"
                });
                line.innerHTML = "<span>A</span><span>rt</span><span>e</span><span>x</span>";
                textElement.appendChild(line);
                if (i === (0, $c660f982237dac0a$export$b3bfe11f31710c32) - 1) (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    opacity: "1"
                });
            }
            textElement.classList.remove((0, $c660f982237dac0a$export$a3e012875989e44));
            textElement.classList.add((0, $c660f982237dac0a$export$a5335760cf6c4e1c));
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 96 : 100, ", \"wght\" ").concat(500),
                fontFeatureSettings: '"dlig"',
                fontSize: (0, $c660f982237dac0a$export$f827a56aa9dbfe62)
            });
        },
        handler: function(progress) {
            var animationProgress = (0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(progress * $569ebc0e763c3fcc$var$duration / $569ebc0e763c3fcc$var$animationDuration, 0, 1);
            var currentIndex = (0, $c660f982237dac0a$export$b3bfe11f31710c32) - Math.floor(((0, $c660f982237dac0a$export$b3bfe11f31710c32) + 1) * animationProgress);
            var line = textElement.children[currentIndex];
            if (line) (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                opacity: "1"
            });
        }
    };
};






var $e5c621aefb72ee83$var$duration = 3000;
var $e5c621aefb72ee83$export$a07f43cc15c6cf79 = function(animationElement, textElement) {
    var line = document.createElement("span");
    line.innerHTML = "MODE<br>PUSH";
    return {
        duration: $e5c621aefb72ee83$var$duration,
        onStart: function() {
            console.log("step 14");
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(true);
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
            (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(255, 0, 0);
            textElement.appendChild(line);
            textElement.classList.remove((0, $c660f982237dac0a$export$a3e012875989e44));
            textElement.classList.remove((0, $c660f982237dac0a$export$a5335760cf6c4e1c));
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                lineHeight: "0.8"
            });
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                fontVariationSettings: "\"wdth\" ".concat(150, ", \"wght\" ").concat(500),
                fontSize: "20vw",
                whiteSpace: "nowrap",
                marginTop: "0.1em",
                marginLeft: "-0.2em"
            });
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                padding: "0.4em"
            });
        },
        onEnd: function() {
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                display: null,
                justifyContent: null,
                alignItems: null,
                flexDirection: null,
                fontVariationSettings: null,
                fontSize: null,
                whiteSpace: null,
                marginTop: null,
                marginLeft: null
            });
        },
        handler: function(progress) {
            var p = (0, $9ee3fca5db518720$exports.easeInOutExpo)(progress, 0, 1, 1);
            var ital = p * 100;
            var wght = p * 400 + 500;
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                fontVariationSettings: "\"wdth\" ".concat(150, ", \"wght\" ").concat(wght, ", \"ital\" ").concat(ital)
            });
        }
    };
};





var $58518efd2df03af2$var$duration = 1000;
var $58518efd2df03af2$var$animationDuration = 1000;
var $58518efd2df03af2$export$cf7f3ecdbbb756f7 = function(animationElement, textElement) {
    return {
        duration: $58518efd2df03af2$var$duration,
        onStart: function() {
            console.log("step 2");
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
        },
        handler: function(progress) {
            var animationProgress = (0, $9ee3fca5db518720$exports.easeInOutExpo)((0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(progress * $58518efd2df03af2$var$duration / $58518efd2df03af2$var$animationDuration, 0, 1), 0, 1, 1);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat(((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 96 : 100) - animationProgress * ((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 46 : 50), ", \"wght\" ").concat(500 - animationProgress * 400)
            });
        }
    };
};





var $8705e14be9cc9703$var$duration = 400;
var $8705e14be9cc9703$var$animationDuration = 400;
var $8705e14be9cc9703$export$59e6aeb8de1c05c6 = function(animationElement, textElement) {
    return {
        duration: $8705e14be9cc9703$var$duration,
        onStart: function() {
            console.log("step 3");
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 255, 0);
        },
        handler: function(progress) {
            var animationProgress = (0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(progress * $8705e14be9cc9703$var$duration / $8705e14be9cc9703$var$animationDuration, 0, 1);
            var num = (0, $c660f982237dac0a$export$358411d2f8db662d).length;
            var currentIndex = num - Math.floor(num * animationProgress);
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            for(var i = 0; i < (0, $c660f982237dac0a$export$b3bfe11f31710c32); i++){
                var line = document.createElement("span");
                line.innerText = (0, $c660f982237dac0a$export$358411d2f8db662d).slice(0, currentIndex);
                textElement.appendChild(line);
            }
        }
    };
};




var $8681e681a7285ab9$var$duration = 1200;
var $8681e681a7285ab9$var$animationDuration = 600;
var $8681e681a7285ab9$export$f449fbc19f39451c = function(animationElement, textElement) {
    return {
        duration: $8681e681a7285ab9$var$duration,
        onStart: function() {
            console.log("step 4");
        },
        handler: function(progress) {
            var animationProgress = (0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(progress * $8681e681a7285ab9$var$duration / $8681e681a7285ab9$var$animationDuration, 0, 1);
            var num = (0, $c660f982237dac0a$export$2cf867adcf7b7e04).length;
            var currentIndex = Math.floor(num * animationProgress);
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            for(var i = 0; i < (0, $c660f982237dac0a$export$b3bfe11f31710c32); i++){
                var line = document.createElement("span");
                line.innerText = (0, $c660f982237dac0a$export$2cf867adcf7b7e04).slice(0, currentIndex);
                textElement.appendChild(line);
            }
        }
    };
};





var $b2d8404e217f2f07$var$duration = 2000;
var $b2d8404e217f2f07$var$animationDuration = 1200;
var $b2d8404e217f2f07$export$5a679d70538da7a7 = function(animationElement, textElement) {
    return {
        duration: $b2d8404e217f2f07$var$duration,
        onStart: function() {
            console.log("step 6");
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
        },
        onEnd: function() {
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontFeatureSettings: null
            });
        },
        handler: function(progress) {
            var animationProgress = progress * $b2d8404e217f2f07$var$duration / $b2d8404e217f2f07$var$animationDuration;
            var lineIndex = 0;
            for(var _i = 0, _a = Array.from(textElement.children); _i < _a.length; _i++){
                var line = _a[_i];
                var wdth = 50 + ((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 96 : 100) * (0, $9ee3fca5db518720$exports.easeInOutExpo)((0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(animationProgress - lineIndex * 0.08, 0, 1), 0, 1, 1);
                var wght = 100 + 800 * (0, $9ee3fca5db518720$exports.easeInOutExpo)((0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(animationProgress - lineIndex * 0.08, 0, 1), 0, 1, 1);
                var ital = 100 * (0, $9ee3fca5db518720$exports.easeInOutExpo)((0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(animationProgress - lineIndex * 0.08, 0, 1), 0, 1, 1);
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    fontVariationSettings: "\"wdth\" ".concat(wdth, ", \"wght\" ").concat(wght, ", \"ital\" ").concat(ital),
                    padding: "1em",
                    margin: "-1em"
                });
                lineIndex++;
            }
        }
    };
};






var $a55bbcc977761b93$var$duration = 3000;
var $a55bbcc977761b93$var$animationDuration = 1500;
var $a55bbcc977761b93$export$5c4017fe9ccd4634 = function(animationElement, textElement) {
    var lastLine = undefined;
    var line = document.createElement("span");
    var wr = (0, $04410b3b959a494a$export$47a3d634abc09f70)(line, [
        {
            text: "A"
        },
        {
            text: "rt",
            style: {
                fontFeatureSettings: '"dlig"'
            }
        },
        {
            text: "e"
        },
        {
            text: "x"
        }
    ]);
    var subSections = (0, $04410b3b959a494a$export$1b1be0204c0cf7ec)([
        {
            percent: 0.5,
            handler: function() {
                wr.render(1, [
                    {
                        text: "A"
                    },
                    {
                        text: "rt",
                        style: {
                            fontFeatureSettings: '"dlig"'
                        }
                    },
                    {
                        text: "e"
                    },
                    {
                        text: "x"
                    }
                ]);
            }
        },
        {
            percent: 1,
            handler: function(progress) {
                wr.render(1, [
                    {
                        text: "A"
                    },
                    {
                        text: "rt",
                        style: {
                            fontFeatureSettings: '"dlig"'
                        }
                    },
                    {
                        text: "e"
                    },
                    {
                        text: "x"
                    }
                ]);
                var animationProgress = (0, $9ee3fca5db518720$exports.easeInOutExpo)(progress, 0, 1, 1);
                var wght = 100 + animationProgress * 800;
                var wdth = ((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 101 : 100) + animationProgress * 50;
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                    fontVariationSettings: "\"wdth\" ".concat(wdth, ", \"wght\" ").concat(wght)
                });
            }
        },
        {
            percent: 0.2,
            handler: function() {}
        },
        {
            percent: 0.3,
            handler: function(progress) {
                wr.render(progress, []);
            }
        },
        {
            percent: 0.2,
            handler: function() {}
        }
    ]);
    return {
        duration: $a55bbcc977761b93$var$duration,
        onStart: function() {
            console.log("step 7");
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(false);
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(235, 233, 230);
            (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(0, 0, 0);
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            // setFadeDuration(1500);
            for(var i = 0; i < (0, $c660f982237dac0a$export$b3bfe11f31710c32); i++){
                var line_1 = document.createElement("span");
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line_1, {
                    opacity: "0"
                });
                line_1.innerText = (0, $c660f982237dac0a$export$358411d2f8db662d);
                textElement.appendChild(line_1);
            }
            textElement.appendChild(line);
            lastLine = textElement.children[textElement.children.length - 1];
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(lastLine, {
                opacity: "1"
            });
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 101 : 100, ", \"wght\" ").concat(100),
                fontFeatureSettings: '"dlig"'
            });
            textElement.classList.add((0, $c660f982237dac0a$export$a5335760cf6c4e1c));
        },
        onEnd: function() {
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(false);
            textElement.classList.remove((0, $c660f982237dac0a$export$a5335760cf6c4e1c));
        },
        handler: function(progress) {
            subSections.compute(progress);
        }
    };
};






var $48698d84ef20fa28$var$duration = 4500;
var $48698d84ef20fa28$var$animationDuration = 4500;
var $48698d84ef20fa28$export$503649f1cf96db83 = function(animationElement, textElement) {
    var container = document.createElement("div");
    var x1 = document.createElement("span");
    x1.innerText = "x";
    var x2 = document.createElement("span");
    x2.innerText = "x";
    var subSections = (0, $04410b3b959a494a$export$1b1be0204c0cf7ec)([
        {
            percent: 0.2,
            handler: function(progress) {
                var p = (0, $9ee3fca5db518720$exports.easeOutExpo)(progress, 0, 1, 1);
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                    transform: "translate(".concat((1 - p) * 100, "%, 0)")
                });
            }
        },
        {
            percent: 0.8,
            handler: function(progress) {
                var animationProgress = (0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)(progress * $48698d84ef20fa28$var$duration / $48698d84ef20fa28$var$animationDuration, 0, 1);
                var mult = Math.abs(progress - 0.5) * 2;
                var p = (0, $9ee3fca5db518720$exports.easeInOutExpo)(mult, 0, 1, 1);
                var wdth = 70 + p * 80;
                var wght = 100 + p * 800;
                var ital = 100 * p;
                var iWdth = 150 - p * 80;
                var iWght = 900 - p * 800;
                var iItal = 100 * (1 - p);
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(x1, {
                    fontVariationSettings: "\"wdth\" ".concat(wdth, ", \"wght\" ").concat(wght, ", \"ital\" ").concat(iItal)
                });
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(x2, {
                    fontVariationSettings: "\"wdth\" ".concat(iWdth, ", \"wght\" ").concat(iWght, ", \"ital\" ").concat(iItal)
                });
            }
        }
    ]);
    return {
        duration: $48698d84ef20fa28$var$duration,
        onStart: function() {
            console.log("step 8");
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(false);
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(235, 233, 230);
            (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(0, 0, 0);
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            container.appendChild(x1);
            container.appendChild(x2);
            textElement.appendChild(container);
            textElement.classList.remove((0, $c660f982237dac0a$export$a3e012875989e44));
            textElement.classList.remove((0, $c660f982237dac0a$export$a5335760cf6c4e1c));
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(x2, {
                fontVariationSettings: "\"wdth\" ".concat(70, ", \"wght\" ").concat(100)
            });
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(x1, {
                fontVariationSettings: "\"wdth\" ".concat(150, ", \"wght\" ").concat(900),
                position: "relative",
                zIndex: "1000000"
            });
            textElement.classList.add("xx");
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                transform: "translate(100%, 0)"
            });
        },
        onEnd: function() {
            textElement.classList.remove("xx");
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(true);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                transform: null
            });
        },
        handler: function(progress) {
            subSections.compute(progress);
        }
    };
};





var $9327f3ee7c8f508c$var$duration = 8000;
var $9327f3ee7c8f508c$var$maxWdth = (0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 96 : 100;
var $9327f3ee7c8f508c$var$finish = false;
var $9327f3ee7c8f508c$export$3b8d96b36dd06153 = function(animationElement, textElement) {
    var line = document.createElement("span");
    var wr = (0, $04410b3b959a494a$export$47a3d634abc09f70)(line);
    var subSections = (0, $04410b3b959a494a$export$1b1be0204c0cf7ec)([
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "a"
                    },
                    {
                        text: "l"
                    },
                    {
                        text: "G",
                        style: {
                            fontFeatureSettings: "'sso1'"
                        }
                    },
                    {
                        text: "g"
                    },
                    {
                        text: "o"
                    },
                    {
                        text: "R"
                    },
                    {
                        text: "r"
                    },
                    {
                        text: "i"
                    },
                    {
                        text: "t"
                    },
                    {
                        text: "h"
                    },
                    {
                        text: "m"
                    }
                ]);
            }
        },
        {
            percent: 0.1,
            handler: function() {}
        },
        {
            percent: 0.03,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "a"
                    },
                    {
                        text: "l"
                    },
                    {
                        text: "G",
                        style: {
                            fontFeatureSettings: "'sso1'"
                        }
                    },
                    {
                        text: "g"
                    },
                    {
                        text: "o"
                    },
                    {
                        text: "R"
                    }
                ]);
            }
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "a"
                    },
                    {
                        text: "l"
                    },
                    {
                        text: "G",
                        style: {
                            fontFeatureSettings: "'sso1'"
                        }
                    },
                    {
                        text: "g"
                    },
                    {
                        text: "o"
                    },
                    {
                        text: "R"
                    },
                    {
                        text: "ri",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"dlig"'
                        }
                    },
                    {
                        text: "t"
                    },
                    {
                        text: "h"
                    },
                    {
                        text: "m"
                    }
                ]);
            }
        },
        {
            percent: 0.06,
            handler: function() {}
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "a"
                    },
                    {
                        text: "l"
                    }
                ]);
            }
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "a"
                    },
                    {
                        text: "l"
                    },
                    {
                        text: "G",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss10"'
                        }
                    },
                    {
                        text: "g"
                    },
                    {
                        text: "o"
                    },
                    {
                        text: "R"
                    },
                    {
                        text: "ri",
                        style: {
                            fontFeatureSettings: '"dlig"'
                        }
                    },
                    {
                        text: "t"
                    },
                    {
                        text: "h"
                    },
                    {
                        text: "m"
                    }
                ]);
            }
        },
        {
            percent: 0.1,
            handler: function() {}
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    }
                ]);
            }
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "a",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "l"
                    },
                    {
                        text: "G",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "g",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "o"
                    },
                    {
                        text: "R",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "r",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "i"
                    },
                    {
                        text: "t"
                    },
                    {
                        text: "h",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "m",
                        style: {
                            color: "rgb(0, 255, 0)",
                            fontFeatureSettings: '"ss01"'
                        }
                    }
                ]);
            }
        },
        {
            percent: 0.1,
            handler: function() {
            // if (!finish) {
            //   setFade(true);
            //   setColor(0, 0, 0);
            //   finish = true;
            // }
            }
        }
    ]);
    return {
        duration: $9327f3ee7c8f508c$var$duration,
        onStart: function() {
            console.log("step 15");
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
            (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(255, 255, 255);
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(false);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                textAlign: "start",
                whiteSpace: "nowrap"
            });
            var emptyLine = document.createElement("span");
            textElement.appendChild(emptyLine.cloneNode());
            textElement.appendChild(emptyLine.cloneNode());
            textElement.appendChild(emptyLine.cloneNode());
            textElement.appendChild(line);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat($9327f3ee7c8f508c$var$maxWdth, ", \"wght\" ").concat(500),
                whiteSpace: "nowrap",
                fontSize: (0, $c660f982237dac0a$export$f827a56aa9dbfe62),
                justifyContent: "flex-end",
                fontFeatureSettings: null
            });
        },
        onEnd: function() {
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(true);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat(96, ", \"wght\" ").concat(500),
                whiteSpace: "nowrap",
                fontSize: (0, $c660f982237dac0a$export$f827a56aa9dbfe62),
                justifyContent: "flex-end",
                fontFeatureSettings: null
            });
        },
        handler: function(progress) {
            subSections.compute(progress);
        }
    };
};






var $0f5d016c9c8ba477$var$duration = 15000;
var $0f5d016c9c8ba477$var$maxWdth = (0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 96 : 100;
var $0f5d016c9c8ba477$var$finish = false;
var $0f5d016c9c8ba477$export$417e13cbf4a7c3 = function(animationElement, textElement) {
    var line = document.createElement("span");
    var wr = (0, $04410b3b959a494a$export$47a3d634abc09f70)(line);
    var subSections = (0, $04410b3b959a494a$export$1b1be0204c0cf7ec)([
        {
            percent: 0.05,
            handler: function(progress) {
                (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 255, 0);
                wr.render(progress, [
                    {
                        text: "M"
                    },
                    {
                        text: "m"
                    },
                    {
                        text: "a"
                    },
                    {
                        text: "G",
                        style: {
                            fontFeatureSettings: "'sso1'"
                        }
                    },
                    {
                        text: "g"
                    },
                    {
                        text: "N"
                    },
                    {
                        text: "n"
                    },
                    {
                        text: "e"
                    },
                    {
                        text: "t"
                    },
                    {
                        text: "i"
                    },
                    {
                        text: "c"
                    }
                ]);
            }
        },
        {
            percent: 0.04,
            handler: function() {}
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "M",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    }
                ]);
            }
        },
        {
            percent: 0.05,
            handler: function(progress) {
                (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(0, 0, 0);
                wr.render(progress, [
                    {
                        text: "M",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "m",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "a",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "G",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "g",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "N",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "n",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "e",
                        style: {
                            color: "rgb(255, 255, 255)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "t",
                        style: {
                            color: "rgb(255, 255, 255)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "i",
                        style: {
                            color: "rgb(255, 255, 255)",
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "c",
                        style: {
                            color: "rgb(255, 255, 255)",
                            fontFeatureSettings: '"ss01"'
                        }
                    }
                ]);
            }
        },
        {
            percent: 0.04,
            handler: function() {}
        },
        {
            percent: 0.1,
            handler: function(progress) {
                var p = (0, $9ee3fca5db518720$exports.easeInOutExpo)(progress, 0, 1, 1);
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    fontVariationSettings: "\"wdth\" ".concat($0f5d016c9c8ba477$var$maxWdth - ($0f5d016c9c8ba477$var$maxWdth - 50) * p, ", \"wght\" ").concat(500)
                });
            }
        },
        {
            percent: 0.02,
            handler: function() {}
        },
        {
            percent: 0.05,
            handler: function(progress) {
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    fontVariationSettings: "\"wdth\" ".concat(50, ", \"wght\" ").concat(500)
                });
                wr.render(progress, []);
            }
        },
        {
            percent: 0.05,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "r",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "t",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "e",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    },
                    {
                        text: "x",
                        style: {
                            fontFeatureSettings: '"ss01"'
                        }
                    }
                ]);
            }
        },
        {
            percent: 0.02,
            handler: function() {}
        },
        {
            percent: 0.04,
            handler: function(progress) {
                wr.render(progress, [
                    {
                        text: "A"
                    }
                ]);
            }
        },
        {
            percent: 0.05,
            handler: function(progress) {
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                    fontFeatureSettings: '"dlig"'
                });
                wr.render(progress, [
                    {
                        text: "A"
                    },
                    {
                        text: "rt",
                        style: {
                            color: "rgb(255, 255, 255)"
                        }
                    },
                    {
                        text: "e"
                    },
                    {
                        text: "x"
                    }
                ]);
            }
        },
        {
            percent: 0.1,
            handler: function(progress) {
                var p = (0, $9ee3fca5db518720$exports.easeInOutExpo)(progress, 0, 1, 1);
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    fontVariationSettings: "\"wdth\" ".concat(50 + ((0, $04410b3b959a494a$export$6446a186d09e379e) || (0, $04410b3b959a494a$export$95df08bae54cb4df) ? 46 : 50) * p, ", \"wght\" ").concat(500)
                });
            }
        },
        {
            percent: 0.02,
            handler: function() {
                (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                    fontVariationSettings: "\"wdth\" ".concat($0f5d016c9c8ba477$var$maxWdth, ", \"wght\" ").concat(500)
                });
            }
        },
        {
            percent: 0.1,
            handler: function() {
                if (!$0f5d016c9c8ba477$var$finish) {
                    (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(true);
                    (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(255, 255, 255);
                    (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
                    $0f5d016c9c8ba477$var$finish = true;
                }
            }
        }
    ]);
    return {
        duration: $0f5d016c9c8ba477$var$duration,
        onStart: function() {
            console.log("step 18");
            $0f5d016c9c8ba477$var$finish = false;
            (0, $04410b3b959a494a$export$751816bfcb437aef)(textElement);
            (0, $51b72d08bf373ed7$export$2e65e79124cca55d)(0, 0, 0);
            (0, $51b72d08bf373ed7$export$130a5dc1bc9cd8e1)(255, 255, 255);
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(false);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(line, {
                textAlign: "start",
                whiteSpace: "nowrap"
            });
            var emptyLine = document.createElement("span");
            textElement.appendChild(emptyLine.cloneNode());
            textElement.appendChild(emptyLine.cloneNode());
            textElement.appendChild(emptyLine.cloneNode());
            textElement.appendChild(line);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat($0f5d016c9c8ba477$var$maxWdth, ", \"wght\" ").concat(500),
                whiteSpace: "nowrap",
                fontSize: (0, $c660f982237dac0a$export$f827a56aa9dbfe62),
                justifyContent: "flex-end",
                fontFeatureSettings: null
            });
        },
        onEnd: function() {
            (0, $51b72d08bf373ed7$export$741788f7de9fd38b)(true);
            (0, $04410b3b959a494a$export$1860c7b6fa9bf376)(textElement, {
                fontVariationSettings: "\"wdth\" ".concat(96, ", \"wght\" ").concat(500),
                whiteSpace: "nowrap",
                fontSize: (0, $c660f982237dac0a$export$f827a56aa9dbfe62),
                justifyContent: "flex-end",
                fontFeatureSettings: null
            });
        },
        handler: function(progress) {
            subSections.compute(progress);
        }
    };
};


var $fe9530e64f7099ab$exports = {};
$fe9530e64f7099ab$exports = new URL("r.3ce1aa41.svg", import.meta.url).toString();


var $95aca61778090f38$exports = {};
$95aca61778090f38$exports = new URL("m.0f82f70b.svg", import.meta.url).toString();


var $6e8f0c81e6ddb3fc$export$df171b5cdc4a4dd8 = [
    (0, $569ebc0e763c3fcc$export$17e504b52161a67b),
    (0, $58518efd2df03af2$export$cf7f3ecdbbb756f7),
    (0, $8705e14be9cc9703$export$59e6aeb8de1c05c6),
    (0, $8681e681a7285ab9$export$f449fbc19f39451c),
    (0, $b2d8404e217f2f07$export$5a679d70538da7a7),
    (0, $a55bbcc977761b93$export$5c4017fe9ccd4634),
    (0, $48698d84ef20fa28$export$503649f1cf96db83),
    // createStep9,
    // createStep13,
    // createStepDezoom(rUrl),
    (0, $9327f3ee7c8f508c$export$3b8d96b36dd06153),
    (0, $e5c621aefb72ee83$export$a07f43cc15c6cf79),
    // createLineSteps(
    //   ["Carbon", "Architecture", "Nanotech"],
    //   [0, 0, 0],
    //   [255, 255, 255]
    // ),
    // createStep17,
    // createDelay(500),
    // createStepDezoom(mUrl),
    // createDelay(500),
    (0, $0f5d016c9c8ba477$export$417e13cbf4a7c3)
];




var $f27a99974ce68c5f$var$Actions;
(function(Actions) {
    Actions["Start"] = "start";
    Actions["Stop"] = "stop";
    Actions["Reset"] = "reset";
})($f27a99974ce68c5f$var$Actions || ($f27a99974ce68c5f$var$Actions = {}));
var $f27a99974ce68c5f$var$colors = [
    {
        background: [
            255,
            0,
            0
        ],
        text: [
            255,
            255,
            255
        ]
    },
    {
        background: [
            234,
            231,
            220
        ],
        text: [
            0,
            0,
            0
        ]
    },
    {
        background: [
            0,
            0,
            0
        ],
        text: [
            255,
            255,
            255
        ]
    },
    {
        background: [
            16,
            121,
            1
        ],
        text: [
            255,
            255,
            255
        ]
    }
];
var $f27a99974ce68c5f$var$main = function() {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var delay = urlParams.get("delay") === "true";
    var animationElement = document.querySelector(".animation");
    var textElement = document.querySelector(".text-container");
    var steps = (0, $6e8f0c81e6ddb3fc$export$df171b5cdc4a4dd8).map(function(it) {
        return it(animationElement, textElement);
    });
    var timeline = new (0, $33b981ac7a75a4a6$exports.Timeline)(steps);
    var animator = new (0, $33b981ac7a75a4a6$exports.Animator)([
        timeline
    ]);
    var firstStep = true;
    var transitionDuration = 1200;
    var colorTransitionDuration = 1000;
    var backgroundChangeTime = 0;
    var currentBackground = (0, $51b72d08bf373ed7$export$ca000e230c0caa3e).background;
    var lastBackground = currentBackground;
    var colorChangeTime = 0;
    var currentColor = (0, $51b72d08bf373ed7$export$ca000e230c0caa3e).color;
    var lastColor = currentColor;
    var stepTime = 0;
    animator.onStep(function(elapsedTime) {
        firstStep = false;
        stepTime = elapsedTime;
    });
    animator.onTick(function(elapsedTime) {
        if ((0, $51b72d08bf373ed7$export$ca000e230c0caa3e).background !== currentBackground) {
            backgroundChangeTime = elapsedTime;
            lastBackground = currentBackground;
            currentBackground = (0, $51b72d08bf373ed7$export$ca000e230c0caa3e).background;
        }
        if ((0, $51b72d08bf373ed7$export$ca000e230c0caa3e).color !== currentColor) {
            colorChangeTime = elapsedTime;
            lastColor = currentColor;
            currentColor = (0, $51b72d08bf373ed7$export$ca000e230c0caa3e).color;
        }
        var bgProgress = (0, $9ee3fca5db518720$exports.easeInOutQuad)((0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)((elapsedTime - backgroundChangeTime) / (0, $51b72d08bf373ed7$export$ca000e230c0caa3e).fadeDuration, 0, 1), 0, 1, 1);
        var cProgress = (0, $9ee3fca5db518720$exports.easeInOutQuad)((0, $04410b3b959a494a$export$7d15b64cf5a3a4c4)((elapsedTime - colorChangeTime) / (0, $51b72d08bf373ed7$export$ca000e230c0caa3e).fadeDuration, 0, 1), 0, 1, 1);
        // const [bR, bG, bA] = interpolateArrays(
        //   bgProgress,
        //   lastBackground,
        //   currentBackground
        // );
        // const [tR, tG, tA] = interpolateArrays(cProgress, lastColor, currentColor);
        if ((0, $51b72d08bf373ed7$export$ca000e230c0caa3e).enableFade) {
            var _a = (0, $04410b3b959a494a$export$dbb89ba2b1e2f9f5)(bgProgress, lastBackground, currentBackground), bR = _a[0], bG = _a[1], bA = _a[2];
            var _b = (0, $04410b3b959a494a$export$dbb89ba2b1e2f9f5)(cProgress, lastColor, currentColor), tR = _b[0], tG = _b[1], tA = _b[2];
            animationElement.style.backgroundColor = "rgb(".concat(bR, ", ").concat(bG, ", ").concat(bA, ")");
            animationElement.style.color = "rgb(".concat(tR, ", ").concat(tG, ", ").concat(tA, ")");
        } else {
            var bR = currentBackground[0], bG = currentBackground[1], bA = currentBackground[2];
            var tR = currentColor[0], tG = currentColor[1], tA = currentColor[2];
            animationElement.style.backgroundColor = "rgb(".concat(bR, ", ").concat(bG, ", ").concat(bA, ")");
            animationElement.style.color = "rgb(".concat(tR, ", ").concat(tG, ", ").concat(tA, ")");
        }
    });
    if (delay) {
        animator.stop();
        animator.startTime = 0;
        animator.computeFrameAt(0);
        window.addEventListener("message", function(_a) {
            var data = _a.data;
            var action = data.action;
            if (action === $f27a99974ce68c5f$var$Actions.Start) animator.start();
            else if (action === $f27a99974ce68c5f$var$Actions.Stop) animator.stop();
            else if (action === $f27a99974ce68c5f$var$Actions.Reset) {
                animator.startTime = 0;
                animator.computeFrameAt(0);
            }
        }, false);
    } else animator.start();
    window.animator = animator;
};
$f27a99974ce68c5f$var$main();


//# sourceMappingURL=index.63d0c776.js.map
